<script setup lang="ts">
import { HeadNavMenuConst } from '@/constant/headNavigationMenu'
import { IsSubAccountConst } from '@/constant/loginRegister'
import useDeveloperStore from '@/stores/developerStore'
import { headNavMenuList } from './config'
import { subAccounJumpHandler, accountJumpHandler } from './helper'
import { useCursor } from './index'
import mittBus from '@/utils/mitt'

defineOptions({ name: 'HeadNavMenuMainContainer' })

defineProps<{
  isTransparentTheme: boolean
}>()

const route = useRoute()
const router = useRouter()
const developerStore = useDeveloperStore()
const { cursorStyle, activatedMainMenuItem } = useCursor()
const notShowLineCursor = computed(() => new Set(['notice', 'noticeDetail', 'contact']).has(route.name as string))

/**
 * 点击主菜单项
 */
const clickMainmenuItem = async (path: string) => {
  if (path === `/${HeadNavMenuConst.ControlCenter}` && !developerStore.isLoggedIn) {
    mittBus.emit('toLogin')
    return
  }

  developerStore.isSubDeveloper === IsSubAccountConst.True
    ? subAccounJumpHandler(path, router)
    : accountJumpHandler(path, router)
}
</script>

<template>
  <div class="head-navigation-menu__mainmenu-container">
    <ul class="head-navigation-menu__mainmenu-list">
      <li v-for="item in headNavMenuList" :id="item.id" :key="item.id" class="head-navigation-menu__mainmenu-item">
        <div
          class="head-navigation-menu__mainmenu-item-link"
          :class="{
            active: activatedMainMenuItem === item.id,
            'transparent-theme': isTransparentTheme
          }"
          @click.stop="clickMainmenuItem(item.path)"
        >
          {{ item.name }}
        </div>
      </li>
    </ul>
    <div class="head-navigation-menu__line">
      <div
        :class="['head-navigation-menu__line-cursor', (isTransparentTheme || notShowLineCursor) && 'transparent-theme']"
      />
    </div>
  </div>
</template>

<style scoped lang="less">
.head-navigation-menu {
  &__mainmenu-container {
    align-self: flex-start;
    width: auto;
    height: 100%;
    min-width: 540px;
  }
  &__mainmenu {
    &-list {
      position: relative;
      display: inline-flex;
      margin-top: 28px;
    }
    &-item {
      box-sizing: border-box;
      padding: 0 20px;
      width: auto;
      height: 24px;
      cursor: pointer;
      &-link {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        transition: color 0.28s ease-in;
        white-space: nowrap;
        &:hover {
          color: rgba(41, 212, 224, 1);
        }
        &.active {
          color: rgba(58, 191, 200, 1);
          font-weight: 700;
        }
        &.transparent-theme {
          color: #ffffff !important;
          &:hover {
            color: #ffffff;
          }
          &.active {
            color: #ffffff;
          }
        }
      }
    }
  }
  &__line {
    position: relative;
    margin-top: 8px;
    height: 4px;
    &-cursor {
      position: absolute;
      top: 0;
      left: v-bind('cursorStyle.left');
      width: v-bind('cursorStyle.width');
      height: 4px;
      border-radius: 100px;
      background-color: rgba(58, 191, 200, 1);
      transition: all 0.2s cubic-bezier(0.24, 0.41, 0.51, 0.9);
      &.transparent-theme {
        background-color: #ffffff;
      }
    }
  }
}
</style>
